import { memoize } from "lodash-es";
import { useMemo, useState } from "react";

import { passwordValidationSchema } from "./PasswordValidation";

const validateSchemaBody = (inputValue: string) => {
  return passwordValidationSchema
    .validate(inputValue, { abortEarly: false })
    .then(() => {
      return new Set();
    })
    .catch(validation => {
      return new Set(validation.errors);
    });
};
const validateSchemaKey = (inputValue: string) => inputValue;

const validateSchema = memoize(validateSchemaBody, validateSchemaKey);

export function usePasswordValidation(inputValue: string) {
  const [errors, setErrors] = useState(new Set());

  const validate = async () => {
    setErrors(await validateSchema(inputValue));
  };

  useMemo(validate, [inputValue]);

  return errors;
}
